import React from 'react';

export interface IncomingCallModalProps {
  remote: string;
  onAccept: () => void;
  onReject: () => void;
}

export function IncomingCallModal({ remote, onAccept, onReject }: IncomingCallModalProps): React.JSX.Element {
  return (
    <section role="dialog" aria-label="Llamada entrante" style={{ padding: 16, border: '1px solid #ccc' }}>
      <h2>Llamada entrante</h2>
      <p>{remote}</p>
      <button type="button" onClick={onAccept}>Aceptar</button>
      <button type="button" onClick={onReject}>Rechazar</button>
    </section>
  );
}
